import { h } from "./dom";

export function showToast(root: HTMLElement, message: string, icon = "🚀", ttlMs = 3700) {
  const el = h("div", { class: "toast" }, [h("span", {}, [icon]), h("span", {}, [message])]);
  root.appendChild(el);
  window.setTimeout(() => el.remove(), ttlMs);
}
